import create from "zustand"

// export const blaaa = {}
export const useStore = create((set, get) => ({
  showOverview: true,
  setShow: v => set({ showOverview: v }),

  index: 0,
  setIndex: v => set({ index: v }),

  direction: 1,

  setDirection: v => set({ direction: v }),

  playing: null,
  setPlaying: v => set({ playing: v }),

  ready: false,
  setReady: v => set({ ready: v })
}))
